import React from "react";
import { Icon } from "antd";
import DragAndDrop from "./../DragAndDrop";
import i18n from "./../../../../../constants/initLng";
import Ripple from "./../Ripple";
import { formatValidation } from "./../../../../../helpers/functions";
import "./styles.less";
import Modal from "../Modal";

export default class UploadVideo extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    this.fileInput = React.createRef();
  }

  onSelectFile = () => {
    !this.props.loading &&
      this.fileInput.current &&
      this.fileInput.current.click();
  };

  onDropFile = (files) => {
    if (files && files.length > 0 && this.props.onChange) {
      return this.props.onChange({ target: { files } });
    }
  };

  onChange = (e) => {
    if (this.props.onChange && e.target.files && e.target.files.length) {
      this.props.onChange(e);
    } else if (this.props.onCancel) {
      this.props.onCancel(e);
    }
    // clear selected file
    this.fileInput.current.value = null;
  };

  onRemoveVideo = (url, index) => {
    const { removeWithoutConfirm } = this.props;
    if (removeWithoutConfirm) {
      return (
        this.props.onRemoveVideo &&
        this.props.onRemoveVideo(url, index)
      );
    }
    const { confirm } = Modal;
    confirm({
      title: formatValidation(i18n.t("validation.statusCode.code.7"), ""),
      okText: i18n.t(`action.remove`),
      cancelText: i18n.t(`action.cancel`),
      onOk: () => {
        this.props.onRemoveVideo &&
          this.props.onRemoveVideo(url, index);
      },
    });
  };

  render() {
    const videoSize = this.props.videoSize || 120;
    const buttonSize = this.props.buttonSize || 120;
    const { className, style, multiple } = this.props;

    return (
      <DragAndDrop
        className={`hms-upload-video ${className}`}
        style={style}
        disabled={this.props.disabledUpload}
        onDrop={this.onDropFile}
        dropText={i18n.t("placeHolderForm.dropVideo")}
      >
        <div className="video-list">
          {!(!multiple && this.props.loading) &&
            (this.props.videoUrls || []).map((url, index) => (
              <div
                key={index}
                className={`video-container-wrapper`}
                style={{
                  position: "relative",
                  width: videoSize,
                  ...(this.props.videoStyle || {}),
                }}
              >
                <div
                  className={`video-container`}
                  style={{ width: videoSize }}
                >
                  <video
                    controls
                    src={url}
                    width={`100%`}
                    className={`cursorPointer`}
                  />
                </div>

                {!this.props.disabledRemove && (
                  <Icon
                    type={"close"}
                    className={`cursorPointer removeVideo`}
                    onClick={(e) => this.onRemoveVideo(url, index)}
                  />
                )}
              </div>
            ))}

          {(this.props.multiple ||
            this.props.loading ||
            !this.props.videoUrls ||
            !this.props.videoUrls.length) &&
            !this.props.disabledUpload && (
              <Ripple
                className="upload-button"
                onClick={this.onSelectFile}
                style={{ width: buttonSize, height: buttonSize }}
              >
                <Icon type={this.props.loading ? "loading" : "plus"} />
                <div className="upload-text">
                  {!this.props.loading
                    ? this.props.uploadText
                    : this.props.loadingText || this.props.uploadText}
                </div>
              </Ripple>
            )}
        </div>
        <input
          ref={this.fileInput}
          type="file"
          name={`file`}
          multiple={this.props.multiple}
          style={{ display: "none" }}
          onChange={this.onChange}
          className={`uploadFile`}
        />
      </DragAndDrop>
    );
  }
}

UploadVideo.defaultProps = {
  removeWithoutConfirm: false,
};
